import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "home-top-wrap flex" }
const _hoisted_2 = { class: "menu-wrap" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "menu-name" }
const _hoisted_5 = {
  key: 0,
  class: "badge-wrap"
}
const _hoisted_6 = {
  key: 1,
  class: "badge-wrap"
}
const _hoisted_7 = {
  key: 2,
  class: "badge-wrap"
}
const _hoisted_8 = { class: "catch-doll-wrap flex flex-column" }
const _hoisted_9 = {
  key: 0,
  class: "dolls-wrap"
}
const _hoisted_10 = { class: "menu-wrap" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "menu-name" }
const _hoisted_13 = {
  key: 0,
  class: "badge-wrap"
}

import { ref, reactive } from 'vue';
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useReddotStore } from '@/store';
import Rule from './Rule';


export default {
  __name: 'HomeTop',
  setup(__props) {

const router = useRouter();
const redDotStore = useReddotStore();
const { loginBonusRewardNum, inboxUnread, taskRewardNum, dailyDepositSign, catchDollLevel } = storeToRefs(redDotStore);

const leftMenuList = reactive([
  { code: 'signUpBonus',  pathName: 'signUp' },
  { code: 'task',  pathName: 'task' },
  { code: 'dailyDepositBonus',  pathName: 'dailyDepositBonus' },
]);

const rightMenuList = reactive([
  { code: 'inbox',  pathName: 'inbox' },
  { code: 'vip',  pathName: 'vip' },
  { code: 'security',  pathName: 'securityCenter' },
])

const showRule = ref(false)

const dollList = ref(['pikachu', 'charmander', 'squirtle', 'snorlax', 'bulbasaur', 'psyduck', 'jigglypuff', 'eevee'])

const clickMenu = item => {
  if(item.onClick) {
    item.onClick()
  } else {
    router.push({ name: item.pathName })
  }
}

return (_ctx, _cache) => {
  const _component_van_image = _resolveComponent("van-image")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(leftMenuList, (item) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "menu-item",
          key: item.code,
          onClick: $event => (clickMenu(item))
        }, [
          _createVNode(_component_van_image, {
            class: "menu-icon",
            fit: "contain",
            src: require(`@/assets/img/home/menu/${item.code}.png`)
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t(`menu.${item.code}`).toUpperCase()), 1),
          (item.code === 'signUpBonus' && _unref(loginBonusRewardNum))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref(loginBonusRewardNum)), 1))
            : (item.code === 'task' && _unref(taskRewardNum))
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref(taskRewardNum)), 1))
              : (item.code === 'dailyDepositBonus' && _unref(dailyDepositSign))
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(dailyDepositSign)), 1))
                : _createCommentVNode("", true)
        ], 8, _hoisted_3)), [
          [_directive_audio]
        ])
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_van_image, {
        class: "claw-img",
        src: require('@/assets/img/catch-doll/claw-2.png')
      }, null, 8, ["src"]),
      (dollList.value.length > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dollList.value, (doll, index) => {
              return (_openBlock(), _createElementBlock("div", null, [
                (_unref(catchDollLevel) > index)
                  ? (_openBlock(), _createBlock(_component_van_image, {
                      key: 0,
                      class: _normalizeClass(`doll-img doll-${index}`),
                      fit: "contain",
                      src: require(`@/assets/img/catch-doll/doll/${doll}.png`)
                    }, null, 8, ["class", "src"]))
                  : _createCommentVNode("", true)
              ]))
            }), 256))
          ]))
        : _createCommentVNode("", true),
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "doll-border" }, null, -1)),
      _createVNode(_component_van_image, {
        class: "logo-title",
        src: require('@/assets/img/common/logo-title.png')
      }, null, 8, ["src"]),
      _createVNode(_component_van_image, {
        class: "help-icon",
        src: require('@/assets/img/catch-doll/help.png'),
        onClick: _cache[0] || (_cache[0] = $event => (showRule.value = true))
      }, null, 8, ["src"])
    ]),
    _createElementVNode("div", _hoisted_10, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(rightMenuList, (item) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          class: "menu-item",
          key: item.code,
          onClick: $event => (clickMenu(item))
        }, [
          _createVNode(_component_van_image, {
            class: "menu-icon",
            fit: "contain",
            src: require(`@/assets/img/home/menu/${item.code}.png`)
          }, null, 8, ["src"]),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t(`menu.${item.code}`).toUpperCase()), 1),
          (item.code === 'inbox' && _unref(inboxUnread))
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(inboxUnread)), 1))
            : _createCommentVNode("", true)
        ], 8, _hoisted_11)), [
          [_directive_audio]
        ])
      }), 128))
    ]),
    (showRule.value)
      ? (_openBlock(), _createBlock(_unref(Rule), {
          key: 0,
          onOnClose: _cache[1] || (_cache[1] = $event => (showRule.value = false))
        }))
      : _createCommentVNode("", true)
  ]))
}
}

}